import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

// This allows copy custom text into user's clipboard.
// This is used for copying MFA secret to clipboard in TOTP registration
Vue.use(VueClipboard)
